import React, { lazy } from 'react';
import { Redirect } from 'react-router';
import { WebUrl } from "../util/Constant";

const Login = lazy(() => import("../pages/Login"));
const Maintenance = lazy(() => import("./../pages/Maintenance"));
const Downline = lazy(() => import("../pages/home/Downline"));
const DownlineDetails = lazy(() => import("../pages/home/DownlineDetails"));
const EditDownline = lazy(() => import("../pages/home/EditDownline"));
const Settings = lazy(() => import("../pages/home/Settings"));
const Kpi = lazy(() => import("../pages/home/Kpi"));
const VideoTutorial = lazy(() => import("../pages/home/VideoTutorial"));
const ContactUs = lazy(() => import("./../pages/home/ContactForm"));
const LiveChatPage = lazy(() => import("./../pages/home/LiveChat"));
const Rewards = lazy(() => import("../pages/home/Rewards"));
const TnC = lazy(() => import("../pages/home/TnC"));
const RewardsTnC = lazy(() => import("../pages/home/RewardsTnC"));
const GamePage = lazy(() => import("../pages/home/GamePage"));
const About = lazy(() => import("../pages/home/About"));
const MainWallet = lazy(() => import("../pages/home/MainWallet"));
const Notification = lazy(() => import("../pages/home/Notification"));
const NotificationDetails = lazy(() => import("../pages/home/NotificationDetails"));
const LoyaltyVoucherDetails = lazy(() => import("../pages/home/LoyaltyVoucherDetails"));
const LoyaltyRedemption = lazy(() => import("../pages/home/LoyaltyRedemption"));
const LoyaltyRedemptionHistory = lazy(() => import("../pages/home/LoyaltyRedemptionHistory"));
const LoyaltyRedemptionTnC = lazy(() => import("../pages/home/LoyaltyRedemptionTnC"));
const Promotion = lazy(() => import("../pages/home/Promotion"));
const PromotionDetail = lazy(() => import("../pages/home/PromotionDetail"));
const Transaction = lazy(() => import("./../pages/transaction/Transaction"));
const Withdrawal2 = lazy(() => import("../pages/transaction/Withdrawal2"));
const WithdrawalRecord = lazy(() => import("./../pages/transaction/WithdrawalRecord"));
const Deposit2 = lazy(() => import("../pages/transaction/Deposit2"));
const DepositRecord = lazy(() => import("./../pages/transaction/DepositRecord"));
const DepositTutorial = lazy(() => import("../pages/transaction/DepositTutorial"));
const GameLobby = lazy(() => import("./../pages/game/GameLobby"));
const UnderMaintenance = lazy(() => import("./../pages/game/UnderMaintenance"));
const ProviderGameLobby = lazy(() => import("../pages/game/ProviderGameLobby"));
const ReportMenu = lazy(() => import("./../pages/report/ReportMenu"));
const WalletHistory = lazy(() => import("./../pages/report/WalletHistory"));
const WalletHistoryMobile = lazy(() => import("./../pages/report/WalletHistoryMobile"));
const CommissionHistory = lazy(() => import("./../pages/report/CommissionHistory"));
const BonusHistory = lazy(() => import("./../pages/report/BonusHistory"));
const InternaTransferHistory = lazy(() => import("./../pages/report/InternaTransferHistory"));
const RolloverHistory = lazy(() => import("./../pages/report/RolloverHistory"));
const TransactionHistory = lazy(() => import("./../pages/report/TransactionHistory"));
const GameHistory = lazy(() => import("./../pages/report/GameHistory"));
const GameDetails = lazy(() => import("../pages/report/GameDetails"));
const RewardsHistory = lazy(() => import("../pages/report/RewardsHistory"));
const RewardsDetail = lazy(() => import("../pages/report/RewardsDetail"));
const WalletTransferHistory = lazy(() => import("../pages/report/WalletTransferHistory"));
const ReloadHistory = lazy(() => import("../pages/report/ReloadHistory"));
const DepositBonusHistory = lazy(() => import("../pages/report/DepositBonusHistory"));
const LoyaltyPointsHistory = lazy(() => import("../pages/report/LoyaltyPointsHistory"));
const ManageReferralCode = lazy(() => import("./../pages/member/ManageReferralCode"));
const ReferralCodeDetail = lazy(() => import("./../pages/member/ReferralCodeDetail"));
const ForgetPin = lazy(() => import("./../pages/member/ForgetPin"));
const DownlineGroupDetail = lazy(() => import("../pages/member/DownlineGroupDetail"));
const MemberProductRateDetail = lazy(() => import("../pages/member/MemberProductRateDetail"));
const UnclaimCommissionHistory = lazy(() => import("../pages/member/UnclaimCommissionHistory"));
const DownlineProductRateDetail = lazy(() => import("../pages/member/DownlineProductRateDetail"));
const Referral = lazy(() => import("../pages/member/Referral"));
const ProductCommRate = lazy(() => import("../pages/member/ProductCommRate"));
const UnclaimLoyaltyPoints = lazy(() => import("../pages/member/UnclaimLoyaltyPoints"));
const CreateReferral = lazy(() => import("../pages/member/CreateReferral"));
const EditReferral = lazy(() => import("../pages/member/EditReferral"));
const Shareholder = lazy(() => import("../pages/shareholder/Shareholder"));
const ShareholderDownline = lazy(() => import("../pages/shareholder/Downline"));
const ShareholderClaim = lazy(() => import("../pages/shareholder/Claim"));
const ShareholderDetails = lazy(() => import("../pages/shareholder/ShareholderDetails"));
const EditShareholder = lazy(() => import("../pages/shareholder/EditShareholder"));
const ClaimRecord = lazy(() => import("../pages/shareholder/ClaimRecord"));
const SummaryDownlineSales = lazy(() => import("../pages/shareholder/SummaryDownlineSales"));
const HelpCentre = lazy(() => import("../pages/setting/HelpCentre"));
const HelpCentreCategory = lazy(() => import("../pages/setting/HelpCentreCategory"));
const HelpCentreSubCategory = lazy(() => import("../pages/setting/HelpCentreSubCategory"));
const HelpCentreFaq = lazy(() => import("../pages/setting/HelpCentreFaq"));
const DailyCheckIn = lazy(() => import("../pages/home/DailyCheckIn"));
const GameProvider = lazy(() => import("../pages/game/GameProvider"));
const Slot = lazy(() => import("../pages/game/Slot"));
const Lottery = lazy(() => import("../pages/game/Lottery"));
const Sport = lazy(() => import("../pages/game/Sports"));
const Casino = lazy(() => import("../pages/game/Casino"));
const RegisterNew = lazy(() => import("../pages/RegisterNew"));
const RegisterSuccess = lazy(() => import("../pages/RegisterSuccess"));
const TermsAndCondition = lazy(() => import("../pages/home/TermsAndCondition"));
const WalletStatement = lazy(() => import("../pages/home/WalletStatement"));
const MyPromo = lazy(() => import("../pages/home/MyPromo"));
const Statement = lazy(() => import("../pages/home/Statement"));
const ProviderLobby = lazy(() => import("../pages/game/ProviderLobby"));
const LastTransaction = lazy(() => import("../pages/report/LastTransaction"));
const ReferralCode = lazy(() => import("../components/my-profile/ReferralCode"));
const ReferralDownline = lazy(() => import("../components/my-profile/ReferralDownline"));
const SpinWheel = lazy(() => import("../pages/member/SpinWheel_New"));
const Congrats = lazy(() => import("../pages/home/Congrats"));
const InactiveDownlines = lazy(() => import("../components/my-profile/InactiveDownlines"));
const TotalCommAndReward = lazy(() => import("../pages/member/TotalCommAndReward"));
const MemberBenefitPage = lazy(() => import("../pages/home/MemberBenefit"));
const Faq = TermsAndCondition;
const HowToPlay = TermsAndCondition;

/// <summary>
/// Author : 
/// </summary>
export const _LOGIN_ROUTE =
{
    path: WebUrl._URL_MAIN,
    exact: false,
    authRequired: false,
    component: () => <Login />
}

export const _ROUTES = [
    {
        path: "/",
        exact: true,
        authRequired: false,
        component: () => <Redirect to={WebUrl._URL_MAIN} />,
    },
    {
        path: "/login",
        exact: true,
        authRequired: false,
        component: () => <Redirect to={WebUrl._URL_MAIN} />,
    },
    {
        path: WebUrl._URL_UNDER_MAINTENANCE,
        exact: true,
        title: 'Under Maintenance',
        authRequired: false,
        component: () => <UnderMaintenance />
    },
    {
        path: WebUrl._URL_MAIN,
        exact: true,
        authRequired: false,
        component: () => <Login />
    },
    // {
    //   path: WebUrl._URL_DASHBOARD,
    //   exact: true,
    //   title: 'Dashboard',
    //   authRequired: true,
    //   component: () => <Redirect to={WebUrl._URL_LOGIN} />
    // },
    // {
    //   path: WebUrl._URL_DASHBOARD_V2,
    //   exact: true,
    //   title: 'DashboardV2',
    //   authRequired: true,
    //   component: () => <Redirect to={WebUrl._URL_LOGIN} />
    // },
    {
        path: WebUrl._URL_SETTINGS,
        exact: true,
        title: 'Settings',
        authRequired: true,
        component: () => <Settings />
    },
    // {
    //   path: WebUrl._URL_REGISTER,
    //   exact: true,
    //   title: 'Register',
    //   authRequired: false,
    //   component: () => <Redirect to={WebUrl._URL_LOGIN} />
    // },
    {
        path: WebUrl._URL_DOWNLINE,
        exact: true,
        title: 'Downline',
        authRequired: true,
        component: () => <Downline />
    },
    {
        path: WebUrl._URL_DOWNLINE_DETAILS,
        exact: true,
        title: 'Downline Details',
        authRequired: true,
        component: () => <DownlineDetails />
    },
    {
        path: WebUrl._URL_EDIT_DOWNLINE,
        exact: true,
        title: 'Edit Downline',
        authRequired: true,
        component: () => <EditDownline />
    },
    {
        path: WebUrl._URL_REPORTS,
        exact: true,
        title: 'Reports',
        authRequired: true,
        component: () => <ReportMenu />
    },
    {
        path: WebUrl._URL_TRANSACTION,
        exact: true,
        title: 'Transaction',
        authRequired: true,
        component: () => <Transaction reload={false} />
    },
    {
        path: WebUrl._URL_RELOAD_TRANSACTION,
        exact: true,
        title: 'Reload',
        authRequired: true,
        component: () => <Transaction reload={true} />
    },
    {
        path: WebUrl._URL_WITHDRAWAL_RECORD,
        exact: true,
        title: 'Withdrawal Record',
        authRequired: true,
        component: () => <WithdrawalRecord />
    },
    {
        path: WebUrl._URL_DEPOSIT_RECORD,
        exact: true,
        title: 'Deposit Record',
        authRequired: true,
        component: () => <DepositRecord />
    },
    {
        path: WebUrl._URL_WALLET_HISTORY,
        exact: true,
        title: 'Wallet History',
        authRequired: true,
        component: () => <WalletHistory />
    },
    {
        path: WebUrl._URL_WALLET_HISTORY_MOBILE,
        exact: true,
        title: 'Wallet History',
        authRequired: true,
        component: () => <WalletHistoryMobile />
    },
    {
        path: WebUrl._URL_TRANSACTION_HISTORY,
        exact: true,
        title: 'Transaction History',
        authRequired: true,
        component: () => <TransactionHistory />
    },
    {
        path: WebUrl._URL_BONUS_HISTORY,
        exact: true,
        title: 'Bonus History',
        authRequired: true,
        component: () => <BonusHistory />
    },
    {
        path: WebUrl._URL_INTERAL_TRASNFER_HISTORY,
        exact: true,
        title: 'Internal Transfer History',
        authRequired: true,
        component: () => <InternaTransferHistory />
    },
    {
        path: WebUrl._URL_WALLET_TRANSFER_HISTORY,
        exact: true,
        title: 'Wallet Transfer History',
        authRequired: true,
        component: () => <WalletTransferHistory />
    },
    {
        path: WebUrl._URL_COMMISSION_HISTORY,
        exact: true,
        title: 'Commission History',
        authRequired: true,
        component: () => <CommissionHistory />
    },
    {
        path: WebUrl._URL_ROLLOVER_HISTORY,
        exact: true,
        title: 'Rollover History',
        authRequired: true,
        component: () => <RolloverHistory />
    },
    {
        path: WebUrl._URL_GAME_HISTORY,
        exact: true,
        title: 'Game History',
        authRequired: true,
        component: () => <GameHistory />
    },
    // {
    //   path: WebUrl._URL_GAME_RESULT,
    //   exact: true,
    //   title: 'Result',
    //   authRequired: true,
    //   component: () => <PoolResult />
    // },
    {
        path: WebUrl._URL_MANAGE_REFERRAL_CODES,
        exact: true,
        title: 'Referral Codes',
        authRequired: true,
        component: () => <ManageReferralCode />
    },
    {
        path: WebUrl._URL_REFERRAL_CODE_DETAIL,
        exact: true,
        title: 'Referral Code Detail',
        authRequired: true,
        component: () => <ReferralCodeDetail />
    },
    {
        path: WebUrl._URL_FORGET_PIN,
        exact: true,
        title: 'Forget PIN',
        authRequired: true,
        component: () => <ForgetPin />
    },
    //{
    //  path: WebUrl._URL_GAME_LOBBY,
    //  exact: true,
    //  title: 'Game Lobby',
    //  authRequired: true,
    //  component: () => <GameLobby />
    //},
    {
        path: WebUrl._URL_KPI,
        exact: true,
        title: 'KPI',
        authRequired: true,
        component: () => <Kpi />
    },
    {
        path: WebUrl._URL_SHAREHOLDER,
        exact: true,
        title: 'Shareholder',
        authRequired: true,
        component: () => <Shareholder />
    },
    {
        path: WebUrl._URL_SHAREHOLDER_DETAIL,
        exact: true,
        title: 'Shareholder Detail',
        authRequired: true,
        component: () => <ShareholderDetails />
    },
    {
        path: WebUrl._URL_EDIT_SHAREHOLDER,
        exact: true,
        title: 'Edit Shareholder',
        authRequired: true,
        component: () => <EditShareholder />
    },
    // {
    //   path: WebUrl._URL_NEWS,
    //   exact: true,
    //   title: 'News',
    //   authRequired: true,
    //   component: () => <News />
    // },
    // {
    //   path: WebUrl._URL_NEWS_DETAILS,
    //   exact: true,
    //   title: 'Detail',
    //   authRequired: true,
    //   component: () => <NewsDetails />
    // },
    {
        path: WebUrl._URL_MAINTENANCE,
        exact: true,
        title: 'Maintenance',
        component: () => <Maintenance />
    },
    {
        path: WebUrl._URL_GAME_DETAILS,
        exact: true,
        title: 'Game Detail',
        authRequired: true,
        component: () => <GameDetails />
    },
    {
        path: WebUrl._URL_CONTACT_US,
        exact: true,
        title: 'Contact Us',
        authRequired: false,
        component: () => <ContactUs />
    },
    {
        path: WebUrl._URL_LIVE_CHAT,
        exact: true,
        title: 'Live Chat',
        component: () => <LiveChatPage />
    },
    {
        path: WebUrl._URL_CLAIM_RECORD,
        exact: true,
        title: 'Claim History',
        component: () => <ClaimRecord />
    },
    {
        path: WebUrl._URL_DOWNLINE_GROUP_DETAIL,
        exact: true,
        title: 'Group Details',
        component: () => <DownlineGroupDetail />
    },
    {
        path: WebUrl._URL_UNCLAIM_COMMISSION_HISTORY,
        exact: true,
        title: 'Unclaim Commission History',
        component: () => <UnclaimCommissionHistory />
    },
    {
        path: WebUrl._URL_TNC,
        exact: true,
        title: 'Terms & Conditions',
        component: () => <TnC />
    },
    {
        path: WebUrl._URL_VIDEO_TUTORIAL,
        exact: true,
        title: 'Video Tutorial',
        authRequired: true,
        component: () => <VideoTutorial />
    },
    {
        path: WebUrl._URL_WITHDRAWAL,
        exact: true,
        title: 'Withdrawal',
        authRequired: true,
        component: () => <Withdrawal2 />
    },
    {
        path: WebUrl._URL_DEPOSIT,
        exact: true,
        title: 'Deposit',
        authRequired: true,
        component: () => <Deposit2 />
    },
    {
        path: WebUrl._URL_SUMMARY_DOWNLINE_SALES,
        exact: true,
        title: 'Summary Downline',
        authRequired: true,
        component: () => <SummaryDownlineSales />
    },
    {
        path: WebUrl._URL_DOWNLINE_PRODUCT_RATE_DETAIL,
        exact: true,
        title: 'Downline Rates',
        authRequired: true,
        component: () => <DownlineProductRateDetail />
    },
    {
        path: WebUrl._URL_REWARDS,
        exact: true,
        title: 'Rewards',
        authRequired: true,
        component: () => <Rewards />
    },
    {
        path: WebUrl._URL_REWARDS_HISTORY,
        exact: true,
        title: 'Rewards History',
        authRequired: true,
        component: () => <RewardsHistory />
    },
    {
        path: WebUrl._URL_REWARDS_DETAIL,
        exact: true,
        title: 'Rewards Detail',
        authRequired: true,
        component: () => <RewardsDetail />
    },
    {
        path: WebUrl._URL_GAME_PAGE,
        exact: true,
        title: 'Game',
        authRequired: true,
        component: () => <GamePage />
    },
    // {
    //   path: WebUrl._URL_CAMO_HOMEPAGE,
    //   exact: true,
    //   title: 'Home Page',
    //   authRequired: true,
    //   component: () => <CamoHomePage />
    // },
    // {
    //   path: WebUrl._URL_CAMO_REGISTER,
    //   exact: true,
    //   title: 'Register',
    //   authRequired: true,
    //   component: () => <CamoRegister />
    // },
    {
        path: WebUrl._URL_REWARDS_TNC,
        exact: true,
        title: 'Rewards Terms & Conditions',
        authRequired: true,
        component: () => <RewardsTnC />
    },
    {
        path: WebUrl._URL_ABOUT_US,
        exact: true,
        title: "About",
        authRequired: false,
        component: () => <About />,
    },
    // {
    //   path: WebUrl._URL_TERMS_AND_CONDITIONS,
    //   exact: true,
    //   title: "Terms and Conditions",
    //   authRequired: false,
    //   component: () => <About />,
    // },
    {
        path: WebUrl._URL_PRIVACY_POLICY,
        exact: true,
        title: "Privacy Policy",
        authRequired: false,
        component: () => <About />,
    },
    {
        path: WebUrl._URL_AFFILIATE_PARTNER_PROGRAM,
        exact: true,
        title: "Affiliate Partner Program",
        authRequired: false,
        component: () => <About />,
    },
    {
        path: WebUrl._URL_RESPONSIBLE_GAMBLING,
        exact: true,
        title: "Responsible Gambling",
        authRequired: false,
        component: () => <TermsAndCondition />,
    },
    {
        path: WebUrl._URL_CONTENT_REFERRAL,
        exact: true,
        title: "Referral",
        authRequired: false,
        component: () => <TermsAndCondition />,
    },
    {
        path: WebUrl._URL_HELP_CENTRE,
        exact: true,
        title: "Help Centre",
        authRequired: false,
        component: () => <HelpCentre />,
    },
    {
        path: WebUrl._URL_HELP_CENTRE_CATEGORY,
        exact: true,
        title: "Help Centre Category",
        authRequired: false,
        component: () => <HelpCentreCategory />,
    },
    {
        path: WebUrl._URL_HELP_CENTRE_SUB_CATEGORY,
        exact: true,
        title: "Help Centre Sub Category",
        authRequired: false,
        component: () => <HelpCentreSubCategory />,
    },
    {
        path: WebUrl._URL_HELP_CENTRE_FAQ,
        exact: true,
        title: "Help Centre Faq",
        authRequired: false,
        component: () => <HelpCentreFaq />,
    },
    //{
    //  path: WebUrl._URL_TRANSFER,
    //  exact: true,
    //  title: "Transfer",
    //  authRequired: false,
    //  component: () => <Transfer />,
    //},
    {
        path: WebUrl._URL_PROVIDER_GAME_LOBBY,
        exact: true,
        title: "Provider Lobby",
        authRequired: false,
        component: () => <ProviderGameLobby />,
    },
    //{
    //  path: WebUrl._URL_MAIN_WALLET,
    //  exact: true,
    //  title: "Main Wallet",
    //  authRequired: false,
    //  component: () => <MainWallet />,
    //},
    {
        path: WebUrl._URL_RELOAD_HISTORY,
        exact: true,
        title: "Reload History",
        authRequired: false,
        component: () => <ReloadHistory />,
    },
    {
        path: WebUrl._URL_NOTIFICATION,
        exact: true,
        title: "Notification",
        authRequired: false,
        component: () => <Notification />,
    },
    {
        path: WebUrl._URL_NOTIFICATION_DETAIL,
        exact: true,
        title: "Notification Detail",
        authRequired: false,
        component: () => <NotificationDetails />,
    },
    {
        path: WebUrl._URL_REFERRAL,
        exact: true,
        title: "Referral",
        authRequired: false,
        component: () => <Referral />,
    },
    {
        path: WebUrl._URL_CREATE_REFERRAL,
        exact: true,
        title: "Create Referral",
        authRequired: false,
        component: () => <CreateReferral />,
    },
    {
        path: WebUrl._URL_EDIT_REFERRAL,
        exact: true,
        title: "Edit Referral",
        authRequired: false,
        component: () => <EditReferral />,
    },
    // {
    //   path: WebUrl._URL_REFERRAL_GROUP,
    //   exact: true,
    //   title: "Referral Group",
    //   authRequired: false,
    //   component: () => <ReferralGroup />,
    // },
    // {
    //   path: WebUrl._URL_REFERRAL_GROUP_DETAILS,
    //   exact: true,
    //   title: "Referral Group Details",
    //   authRequired: false,
    //   component: () => <ReferralGroupDetails />,
    // },
    // {
    //   path: WebUrl._URL_COMMISSION,
    //   exact: true,
    //   title: "Commission",
    //   authRequired: false,
    //   component: () => <Commission />,
    // },
    {
        path: WebUrl._URL_LOYALTY_REDEMPTION,
        exact: true,
        title: "Loyalty Redemption",
        authRequired: true,
        component: () => <LoyaltyRedemption />,
    },
    {
        path: WebUrl._URL_LOYALTY_REDEMPTION_HISTORY,
        exact: true,
        title: "Loyalty Redemption History",
        authRequired: true,
        component: () => <LoyaltyRedemptionHistory />,
    },
    {
        path: WebUrl._URL_LOYALTY_REDEMPTION_TNC,
        exact: true,
        title: "Loyalty Redemption TnC",
        authRequired: true,
        component: () => <LoyaltyRedemptionTnC />,
    },
    //{
    //  path: WebUrl._URL_UNCLAIM_LOYALTY_POINTS,
    //  exact: true,
    //  title: "Unclaim Loyalty Points",
    //  authRequired: true,
    //  component: () => <UnclaimLoyaltyPoints />,
    //},
    {
        path: WebUrl._URL_LOYALTY_POINTS_HISTORY,
        exact: true,
        title: "Loyalty Points History",
        authRequired: true,
        component: () => <LoyaltyPointsHistory />,
    },
    {
        path: WebUrl._URL_PRODUCT_COMM_RATE,
        exact: true,
        title: "Product Comm Rate",
        authRequired: true,
        component: () => <ProductCommRate />,
    },
    {
        path: WebUrl._URL_SHAREHOLDER_DOWNLINE,
        exact: true,
        title: "Downline",
        authRequired: true,
        component: () => <ShareholderDownline />,
    },
    {
        path: WebUrl._URL_SHAREHOLDER_CLAIM,
        exact: true,
        title: "Claim",
        authRequired: true,
        component: () => <ShareholderClaim />,
    },
    {
        path: WebUrl._URL_LOYALTY_VOUCHER_DETAILS,
        exact: true,
        title: "Voucher Details",
        authRequired: true,
        component: () => <LoyaltyVoucherDetails />,
    },
    {
        path: WebUrl._URL_DEPOSIT_TUTORIAL,
        exact: true,
        title: "Deposit Tutorial",
        authRequired: true,
        component: () => <DepositTutorial />,
    },
    {
        path: WebUrl._URL_DEPOSIT_BONUS_HISTORY,
        exact: true,
        title: "Deposit Bonus History",
        authRequired: true,
        component: () => <DepositBonusHistory />,
    },
    {
        path: WebUrl._URL_DAILY_CHECK_IN,
        exact: true,
        title: "Daily Check In",
        authRequired: true,
        component: () => <DailyCheckIn />,
    },
    {
        path: WebUrl._URL_PROMOTION,
        exact: true,
        title: "Promotion Lobby",
        component: () => <Promotion />,
    },
    {
        path: WebUrl._URL_PROMOTION_DETAIL,
        exact: true,
        title: "Promotion Detail",
        component: () => <PromotionDetail />,
    },
    {
        path: WebUrl._URL_MEMBER_PRODUCT_RATE_DETAIL,
        exact: true,
        title: "Product Rate %",
        component: () => <MemberProductRateDetail />,
    },
    {
        path: WebUrl._URL_GAME_PROVIDER_LIST,
        exact: true,
        title: "Game Provider",
        component: () => <GameProvider />,
    },
    {
        path: WebUrl._URL_SLOT,
        exact: true,
        title: "Esport",
        authRequired: true,
        component: () => <Slot />,
    },
    {
        path: WebUrl._URL_LOTTERY,
        exact: true,
        title: "Lottery",
        authRequired: true,
        component: () => <Lottery />,
    },
    {
        path: WebUrl._URL_SPORT,
        exact: true,
        title: "Sport",
        authRequired: true,
        component: () => <Sport />,
    },
    {
        path: WebUrl._URL_CASINO,
        exact: true,
        title: "Casino",
        authRequired: true,
        component: () => <Casino />,
    },
    {
        path: WebUrl._URL_REGISTER,
        exact: true,
        title: "Register",
        component: () => <RegisterNew />,
    },
    {
        path: WebUrl._URL_REGISTER_SUCCESS,
        exact: true,
        title: "Registration Success",
        authRequired: false,
        component: () => <RegisterSuccess />,
    },
    {
        path: WebUrl._URL_FAQ,
        exact: true,
        title: "Faq",
        component: () => <TermsAndCondition />,
    },
    {
        path: WebUrl._URL_HOW_TO_PLAY,
        exact: true,
        title: "How To Play",
        component: () => <TermsAndCondition />,
    },
    {
        path: WebUrl._URL_TERMS_AND_CONDITIONS,
        exact: true,
        title: "Terms and Conditions",
        component: () => <TermsAndCondition />,
    },
    {
        path: WebUrl._URL_WALLET_STATEMENT,
        exact: true,
        title: "Wallet Statement",
        authRequired: true,
        component: () => <WalletStatement />,
    },
    {
        path: WebUrl._URL_MY_PROMO,
        exact: true,
        title: "My Promo",
        component: () => <MyPromo />,
    },
    {
        path: WebUrl._URL_STATEMENT,
        exact: true,
        title: "Statement",
        authRequired: true,
        component: () => <Statement />,
    },
    {
        path: WebUrl._URL_PROVIDER_LOBBY,
        exact: true,
        title: "Game Lobby",
        component: () => <ProviderLobby />,
    },
    {
        path: WebUrl._URL_LAST_TRANSACTION,
        exact: true,
        title: "Last 5 Transaction",
        component: () => <LastTransaction />,
    },
    {
        path: WebUrl._URL_REFERRAL_CODE_UG,
        exact: true,
        title: "Referral Code",
        component: () => <ReferralCode />,
    },
    {
        path: WebUrl._URL_DOWNLINE_UG,
        exact: true,
        title: "Downlie",
        component: () => <ReferralDownline />,
    },
    {
        path: WebUrl._URL_SPIN_WHEEL,
        exact: true,
        title: "Spin Wheel",
        component: () => <SpinWheel />,
    },
    {
        path: WebUrl._URL_CONGRATS,
        exact: true,
        title: "Congrats",
        component: () => <Congrats />,
    },
    {
        path: WebUrl._URL_INACTIVE_DOWNLINES,
        exact: true,
        title: "Inactive Downlines",
        component: () => <InactiveDownlines />,
    },
    {
        path: WebUrl._URL_TOTAL_COMMISION,
        exact: true,
        title: "Total Commision and Reward",
        component: () => <TotalCommAndReward />,
    },
    {
        path: WebUrl._URL_MEMBER_BENEFIT_PAGE,
        exact: true,
        title: "Member Benefit",
        authRequired: false,
        component: () => <MemberBenefitPage />,
    },
];